/**
 * Affiliate Tracking Service (client)
 *
 * Sends affiliate-link click events to the backend. The backend records
 * the click + sets the referral cookie (HttpOnly, parent domain) — the
 * client never reads or writes the cookie itself.
 */

const defaultApiUrl =
  process.env.NODE_ENV === 'production' ? 'https://api.saillab.co.jp' : 'http://localhost:5000';

const API_BASE_URL = `${process.env.REACT_APP_API_URL || defaultApiUrl}/api`;

export interface TrackClickResult {
  ok: boolean;
  status: string;
}

/**
 * POST /api/affiliate/track-click. Always silent on the user's side — failures
 * are logged in dev only and never surface as toasts. Includes credentials so
 * the Set-Cookie response header is honored on cross-subdomain requests.
 */
export const trackAffiliateClick = async (code: string): Promise<TrackClickResult> => {
  try {
    const res = await fetch(`${API_BASE_URL}/affiliate/track-click`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        code,
        referer: typeof document !== 'undefined' ? document.referrer || undefined : undefined,
      }),
    });
    if (!res.ok) {
      return { ok: false, status: `http_${res.status}` };
    }
    return (await res.json()) as TrackClickResult;
  } catch {
    return { ok: false, status: 'network_error' };
  }
};

export default { trackAffiliateClick };
